module.exports = __webpack_public_path__ + "static/img/13areaA_3.90fc865.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/13areaA_3.png
// module id = 794
// module chunks = 1